<app-generic-field [label]="label" [hideLabel]="hideLabel">
  <div class="container" [tabindex]="0"
       (click)="toggle()" (keydown.space)="toggle()" (keydown.enter)="toggle()">
    <div class="text">{{value ? textLabels[0] : textLabels[1]}}</div>
    <div class="checked-icon" *ngIf="value"><i class="fas fa-check"></i></div>
  </div>
</app-generic-field>
